module.exports = __webpack_public_path__ + "packs/media/images/Slider_3-4855d46a19a3b2a095f4d5eb5d7e27f7.jpg";